import React from 'react';

import { Box } from '@components/Restyle';

/**
 * The "display 3 rows of outline for list/table area even if it has no
 * data yet" global rule (TA-10089), generically. Renders `count` copies of
 * `row`, each wrapped so callers don't need to key/space them individually.
 */
interface SkeletonListProps {
  row: (index: number) => React.ReactNode;
  count?: number;
  testID?: string;
}

export const SkeletonList: React.FC<SkeletonListProps> = ({
  row,
  count = 3,
  testID = 'skeleton-list',
}) => {
  return (
    <Box testID={testID}>
      {Array.from({ length: count }, (_, index) => (
        <React.Fragment key={index}>{row(index)}</React.Fragment>
      ))}
    </Box>
  );
};
